import React, { useCallback, useMemo, useState }    from 'react';
import { Pressable, View }                          from 'react-native';
import { useTheme, Button, Dialog, Text }           from '@rneui/themed';
import { getMonth, getYear, getDate, getDay, getDaysInMonth, startOfMonth, format, parse } from 'date-fns';
import PropTypes                                    from 'prop-types';

const DAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

export const WebDateTimePicker = props =>  
{
    const today                               = useMemo(() => new Date(Date.now()), []);
    const { theme }                           = useTheme();
    const [ state, setState ]                 = useState({
        month: getMonth(today) + 1,
        selectedDate: today,
        visible: true,
        year: getYear(today)
    })

    const onNavigate  = useCallback(isPrevious => {
        let month = state.month;
        let year  = state.year;

        if (isPrevious) {
            if (month === 1) {
                year  = year - 1;
                month = 12;
            }
            else {
                month = month - 1;
            }
        }
        else {
            if (month === 12) {
                year  = year + 1;
                month = 1;
            }
            else {
                month = month + 1;
            }
        }

        setState({ ...state, month, year });
    }, [ state ]);

    const isToday = useCallback(date => {
        const todaysDate = getDate(today);

        if (date === todaysDate) {
            return true;
        }

        return false;
    }, [today]);

    const renderMonth = useCallback(() =>
    {
        const monthDate = parse(`${state.year}-${state.month}`, 'yyyy-M', new Date());
        const daysInMonthCount = getDaysInMonth(monthDate);
        const startOfMonthDay = getDay(startOfMonth(monthDate));
        const todayDate = getDay(today);
        const cells = [];
        let dayCounter = 1;

        const renderCell = (index, text, onPress, style) => {
            const handlePress = () => {
                if (onPress) {
                    onPress(parse(`${text}-${state.month}-${state.year}`, 'd-M-yyyy', new Date()));
                }
            };

            return (
                <Pressable key={`webdatepicker-${index}`} onPress={handlePress}>
                    <View style={{...style, height: 50, width: 50}}>
                        {
                            text &&
                                <Text numberOfLines={1} style={style?.text ||  theme?.appComponents?.common?.WebDateTimePicker?.month}
                                    >
                                    { text }
                                </Text>
                        }
                    </View>
                </Pressable>
            );
        };

        for (let x = 0 - startOfMonthDay; x < daysInMonthCount; x++) {
            const isTodaysDate = isToday(dayCounter);

            const style = { 
                ...theme?.appComponents?.common?.WebDateTimePicker?.dateCellStyle, 
                backgroundColor: isTodaysDate ? theme?.appComponents?.common?.WebDateTimePicker?.isTodaysDate?.backgroundColor
                                              : undefined,
                text: {
                    ...theme?.appComponents?.common?.WebDateTimePicker?.textStyle, 
                    color: isTodaysDate ? theme?.appComponents?.common?.WebDateTimePicker?.isTodaysDate?.color
                                        : theme?.appComponents?.common?.WebDateTimePicker?.textStyle.color,
                },
            };
             
            cells.push(renderCell(x, x >= 0 ? dayCounter++ : undefined, props.onSelect, style));
        }

        return (
            <View>
                <View style={{ alignItems: 'center', flexDirection: 'row', justifyContent: 'center' }}>
                    {
                        DAYS.map((day, index) => renderCell(index, day))
                    }
                </View>
                <View style={{flexDirection: 'row', flexWrap: 'wrap'}}>
                    { cells }
                </View>
            </View>
        );
    }, [ state.month, state.year ]);

    return (
        <Dialog backdropStyle={{backgroundColor: theme?.colors?.black, opacity: 0.30}} 
                isVisible={state.visible}
                onBackdropPress={() => setState({...state, visible: false})}
                overlayStyle={{ borderRadius: 10, minHeight: 400, width: 400 }}
        >
            <View style={{alignItems: 'center', flexDirection: 'row', justifyContent: 'space-evenly', marginBottom: 5}}>
                <Button buttonStyle={{ backgroundColor: 'transparent' }}
                        icon={theme?.appComponents?.common?.WebDateTimePicker?.leftBtnIcon}
                        onPress={() => onNavigate(true)}
                />
                <Text numberOfLines={1} style={theme?.appComponents?.common?.WebDateTimePicker?.monthYear}
                    >
                    { format(parse(`${state.year}-${state.month}`, 'yyyy-M', new Date()), 'MMMM yyyy') }
                </Text>
                <Button buttonStyle={{ backgroundColor: 'transparent' }}
                        icon={theme?.appComponents?.common?.WebDateTimePicker?.rightBtnIcon}
                        onPress={() => onNavigate(false)}
                />
            </View>
            { renderMonth() }
        </Dialog>    
    );
};

WebDateTimePicker.defaultProps = {
    onSelect: () => {},
    value: new Date()
};

WebDateTimePicker.propTypes = {
    onSelect: PropTypes.func,
    value: PropTypes.instanceOf(Date)
}

export default WebDateTimePicker;
